const onDOMContentLoaded = () => {
  document.body.classList.remove('preload');

  bindSidebar();
  bindDatalists();
};

document.addEventListener('DOMContentLoaded', onDOMContentLoaded);

function bindSidebar() {
  const sidebar = document.querySelector<HTMLElement>('.dashboard-sidebar-container');
  const sidebarToggle = document.querySelector<HTMLElement>('.dashboard-sidebar-toggle');
  const contentToggle = document.querySelector<HTMLElement>('.dashboard-content-toggle');

  if (!sidebar || !sidebarToggle || !contentToggle) {
    return;
  }

  sidebarToggle.addEventListener('click', () => {
    sidebar.classList.toggle('collapsed', false);
    sidebarToggle.style.display = 'none';
    contentToggle.style.display = 'flex';
  });

  contentToggle.addEventListener('click', () => {
    sidebar.classList.toggle('collapsed', true);
    contentToggle.style.display = 'none';
    sidebarToggle.style.display = 'flex';
  });
}

const bindDatalists = () => {
  const updateLabel = (input: HTMLInputElement) => {
    if (!input.parentNode) {
      return;
    }

    const label = input.parentNode.querySelector<HTMLInputElement>('input[data-label]');

    if (!label || !input.list) {
      return;
    }

    const option = input.list.querySelector(`[value="${input.value}"`);
    label.value = option ? option.getAttribute('label') ?? '' : '';
  };

  document.querySelectorAll<HTMLInputElement>('input[list]').forEach(function (input) {
    input.addEventListener('change', function () {
      updateLabel(input);
    });

    updateLabel(input);
  });
};
